import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { CartService } from '../../../core/services/cart.service';

@Component({
    selector: 'app-bottom-nav',
    standalone: true,
    imports: [CommonModule, RouterLink, RouterLinkActive],
    templateUrl: './bottom-nav.component.html',
    styleUrls: ['./bottom-nav.component.scss']
})
export class BottomNavComponent {
    private router = inject(Router);
    private cartService = inject(CartService);

    // Cart item count for badge
    cartItemCount = this.cartService.cartItemCount;

    // Navigation items
    navItems = [
        {
            label: 'Home',
            route: '/',
            icon: '🏠',
            exact: true
        },
        {
            label: 'Shop',
            route: '/shop',
            icon: '🛍️',
            exact: false
        },
        {
            label: 'Cart',
            route: '/cart',
            icon: '🛒',
            exact: false,
            showBadge: true
        },
        {
            label: 'More',
            route: '/profile-hub',
            icon: '⋯',
            exact: false
        }
    ];

    /**
     * Check if a route is active
     */
    isRouteActive(route: string, exact: boolean): boolean {
        if (exact) {
            return this.router.url === route;
        }
        return this.router.url.startsWith(route);
    }
}
